declare global {
  interface Window {
    market: {
      id: string;
      handle: string;
      currency: string;
      countryCode?: string;
    };
    reactifyOverride?: {
      forceAuMarket: boolean;
      auMarketId: string;
    };
  }
}

export const isAuMarketOverrideEnabled = (): boolean => {
  const override = window.reactifyOverride;
  return Boolean(override?.forceAuMarket && override?.auMarketId);
};

export const resolveReactifyMarketId = (): string => {
  if (isAuMarketOverrideEnabled()) {
    return window.reactifyOverride!.auMarketId;
  }
  return window.market.id;
};
